// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import axiosInstance,{testurl} from "../axiosInstance";
import io from "socket.io-client";
import messageAlertSound from "../assets/audio/message.mp3"; // Import the sound file
import getCookie from "../helpers/getCookie";
import eraseCookie from "../helpers/eraseCookie";
import getDecryptData from "../helpers/getDecryptData";

const socket = io(testurl);

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [getAuth, setAuth] = useState([]);
  const [Headers, setHeaders] = useState([]);

  const [getAuthTime, setAuthTimer] = useState([]);

 
  const dataAuth = async () => {
    
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    const credentials = {
      id: id,
    };
    const authuser = getCookie("token");
    if (!authuser) {
      return;
    }

    try {
      const { data } = await axiosInstance.post("/auth-user", credentials);

      const { success, existingUser,activeOrders } = data;
      if (success) {
        console.log('mytype',existingUser);
        setAuth(existingUser);
        if(activeOrders && activeOrders.length !== 0 ){
        setAuthTimer(activeOrders);
        }

      const {data} = await axiosInstance.get("/home-data");
      console.log('homedata',data.homeData);
  setAuth((prevData) => ({
      ...prevData,
       limit: data.homeData.withdrawalAmt || 1000,
    }));
    
      } else if (data.success === false) {
        toast.error(data.message);
        eraseCookie("token");
      }
      
    } catch (error) {
      console.log(error);
    }
  };

    const getHeader = async () => {
 
            try {

                const { data } = await axiosInstance.get(`/home-data`);
                setHeaders(data.homeData);
                console.log('data', data.homeData);
 
  
            }
            catch (error) {
                console.log(error);
             }
      


    };

    const [notification, setNotification] = useState([]);
  const [AllMessages, setAllMessages] = useState([]);
    const [AllBookReq, setBookReq] = useState([]);
        const [allRemoveId, setAllRemoveId] = useState([]);


  const [AllRideReq, setRideReq] = useState([]);

  const [AllValetReq, setValetReq] = useState([]);

  const [ParkingReq, setParkingReq] = useState([]);

  const [AllLocationReq, setLocationReq] = useState([]);
  const [NotificationCount, setNotificationCount] = useState(0);


  useEffect(() => {
    const decryptdatajson = getDecryptData();
    const userId = decryptdatajson?._id;

    socket.on("chat message", (message) => {
      console.log("messagemessagemessagemessage", message);
      if (message.type === "message") {
        console.log("get message");
        // Add date and time to the message object before updating state
        const messageWithDateTime = {
          ...message,
          time: formatTimestamp(new Date()),
        };

        setAllMessages((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
        // if (message.userId !== userId) {
        //     playMessageAlert(); // Play sound alert if the message sender is the current user

        //    }
      }
      if (message.type === "notification") {
        setNotification((prevMessages) => {
          const newMessages = [...prevMessages];
          return newMessages;
        });
      }
      if (message.type === "book") {
        // Add date and time to the message object before updating state
        const messageWithDateTime = { ...message };
        setBookReq((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
      }
      if (message.type === "ride") {
        // Add date and time to the message object before updating state
        const messageWithDateTime = { ...message };
        setRideReq((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
      }
      if (message.type === "valet") {
        // Add date and time to the message object before updating state
        const messageWithDateTime = { ...message };
        setValetReq((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
      }
      if (message.type === "parking") {
        const messageWithDateTime = { ...message };
        setParkingReq((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
      }
      if (message.type === "location") {
        const messageWithDateTime = { ...message };
        setLocationReq((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
      }


    });

    return () => {
      socket.off("chat message");
    };
  }, []);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: "long", // Use 'long' to display the full month name
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  const playMessageAlert = () => {
    const sound = new Audio(messageAlertSound);
    sound.play();
  };

  const removeNotification = () => {
    setNotification([]);
  };
  const removeBook = () => {
    setBookReq([]);
  };

const removeOrders = (id) => {
  setAllRemoveId(prevIds => {
    const updatedRemoveIds = [...prevIds, id];
    const updatedOrders = AllBookReq.filter(order => !updatedRemoveIds.includes(order.orderId));
    setBookReq(updatedOrders);
    return updatedRemoveIds;
  });
};
 


  const removeRide = () => {
    setRideReq([]);
  };

  const removeParkingReq = () => {
    setParkingReq([]);
  };

  const removeNotificationcount = () => {
    setNotificationCount(0);
  };

  const sendMessage = (message) => {
    socket.emit("chat message", message);
  };

  const sendNotification = (notification) => {
    socket.emit("notification message", notification);
  };

  const sendRideReq = (ridereq) => {
    console.log("ridereq", ridereq);
    socket.emit("ride notification", ridereq);
  };


  useEffect(() => {
    dataAuth();
    getHeader();
  }, []);

  return (
    <ThemeContext.Provider
      value={{
        getAuth,
        dataAuth,
        AllBookReq,
        removeBook,
        removeOrders,allRemoveId, setAllRemoveId,sendMessage,getAuthTime,Headers
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within a ThemeProvider");
  }
  return context;
};
